import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import {
  cloneColorGradeSnapshot,
  type ColorGradeSnapshotEntry,
} from '@/features/effects/utils/color-grade'

export interface ColorGradePreset {
  id: string
  name: string
  grade: ColorGradeSnapshotEntry[]
  createdAt: number
  updatedAt: number
}

interface ColorGradePresetsState {
  presets: ColorGradePreset[]
  savePreset: (name: string, grade: ColorGradeSnapshotEntry[]) => ColorGradePreset | null
  removePreset: (id: string) => void
}

function normalizePresetName(value: string): string {
  return value.trim().replace(/\s+/g, ' ')
}

export const useColorGradePresetsStore = create<ColorGradePresetsState>()(
  persist(
    (set) => ({
      presets: [],

      savePreset: (name, grade) => {
        const normalizedName = normalizePresetName(name)
        if (!normalizedName || grade.length === 0) {
          return null
        }

        const now = Date.now()
        const preset: ColorGradePreset = {
          id: crypto.randomUUID(),
          name: normalizedName,
          grade: cloneColorGradeSnapshot(grade),
          createdAt: now,
          updatedAt: now,
        }

        set((state) => ({
          presets: [preset, ...state.presets],
        }))

        return preset
      },

      removePreset: (id) =>
        set((state) => ({
          presets: state.presets.filter((preset) => preset.id !== id),
        })),
    }),
    {
      name: 'freecut-color-grade-presets',
      partialize: (state) => ({
        presets: state.presets.map((preset) => ({
          ...preset,
          grade: cloneColorGradeSnapshot(preset.grade),
        })),
      }),
    },
  ),
)
